import React from 'react';
import { PendingChangesDot } from '~/components/common/FlowTemplates/FlowPendingChanges/FlowPendingChanges.styles';
import HBText from '@honeybook/hbui/dist/components/HBText/HBText';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { NAMESPACES } from '~/i18n/namespaces';

interface Props {
    isLeadForm?: boolean;
    isDeactivated?: boolean;
}

const PendingChangesText = ({ isLeadForm, isDeactivated }: Props) => {
    const { t } = useTranslation(NAMESPACES.TEMPLATES, {
        keyPrefix: 'pending_changes'
    });

    const transKey = (() => {
        if (isLeadForm) {
            return isDeactivated
                ? 'public_forms_inactive'
                : 'public_forms_live';
        }
        return 'template_text';
    })();

    return (
        <PendingChangesTextContainer>
            <StyledText>
                <PendingChangesInlineDot />
            </StyledText>
            <StyledTextLine>{t(transKey)}</StyledTextLine>
        </PendingChangesTextContainer>
    );
};

export default PendingChangesText;

// -------------------------------- Styles -------------------------------- //
const PendingChangesTextContainer = styled.div`
    padding-top: 2px;
    display: flex;
`;

const StyledText = styled(HBText).attrs({
    type: 'body12',
    color: 'neutral700'
})``;

const StyledTextLine = styled(StyledText)`
    white-space: pre-wrap;
`;

const PendingChangesInlineDot = styled(PendingChangesDot).attrs({
    diameter: 6
})`
    display: inline-block;
    margin-right: 6px;
`;
